class ExplicitVariantController extends HTMLElement {
  static get DROPDOWN_PLACEHOLDER() {
    return '—';
  }

  connectedCallback() {
    this.formId = this.getAttribute('form-id');
    this.initText = this.getAttribute('data-init-text') || '';
    this.readyText = this.getAttribute('data-ready-text') || '';
    this.form = this.formId ? document.forms[this.formId] : null;
    this.productRerender = this.formId
      ? document.querySelector('product-rerender[observe-form="' + this.formId + '"]')
      : null;
    this.userClickedPositions = new Set();

    if (!this.form || !this.productRerender) return;

    this.onOptionChange = this.onOptionChange.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);

    this.form.addEventListener('change', this.onOptionChange);
    this.form.addEventListener('variant:change', this.onVariantChange);

    this.refresh();
  }

  disconnectedCallback() {
    if (!this.form) return;
    this.form.removeEventListener('change', this.onOptionChange);
    this.form.removeEventListener('variant:change', this.onVariantChange);
  }

  getPicker() {
    return this.productRerender.querySelector(
      'variant-picker[form-id="' + this.formId + '"][data-require-explicit-selection]'
    );
  }

  totalOptionCount(picker) {
    const positions = new Set();
    picker.querySelectorAll('input[data-option-position]').forEach((input) => {
      positions.add(input.getAttribute('data-option-position'));
    });
    return positions.size;
  }

  refresh() {
    const picker = this.getPicker();
    if (!picker) return;

    picker.querySelectorAll('input[data-option-position]').forEach((input) => {
      const pos = input.getAttribute('data-option-position');
      if (!this.userClickedPositions.has(pos)) {
        input.checked = false;
      }
    });

    picker.querySelectorAll('fieldset.variant-picker__option').forEach((fieldset) => {
      const firstRadio = fieldset.querySelector('input[data-option-position]');
      if (!firstRadio) return;
      const pos = firstRadio.getAttribute('data-option-position');
      if (this.userClickedPositions.has(pos)) return;

      const valueLabel = fieldset.querySelector('.variant-picker__option-info .h-stack > span');
      if (valueLabel) valueLabel.textContent = '';

      const dropdownLabel = fieldset.querySelector('button.select > span[id$="-selected-value"]');
      if (dropdownLabel) dropdownLabel.textContent = ExplicitVariantController.DROPDOWN_PLACEHOLDER;
    });

    this.updateAtc(picker);
  }

  updateAtc(picker) {
    const total = this.totalOptionCount(picker);
    const ready = total > 0 && this.userClickedPositions.size >= total;

    this.productRerender.querySelectorAll('buy-buttons button[type="submit"]').forEach((btn) => {
      this.setSubmitState(btn, ready);
    });

    document
      .querySelectorAll('product-sticky-bar[form="' + this.formId + '"] buy-buttons button[type="submit"]')
      .forEach((btn) => {
        this.setSubmitState(btn, ready);
      });

    if (!ready && this.form.elements.id) {
      this.form.elements.id.value = '';
    }
  }

  setSubmitState(btn, ready) {
    btn.disabled = !ready;
    if (ready) {
      btn.removeAttribute('aria-disabled');
      // Only restore the ready label if the button is still showing our init text —
      // avoids clobbering states like "Sold out" set by other handlers.
      if (this.readyText && this.initText && btn.textContent.trim() === this.initText.trim()) {
        btn.textContent = this.readyText;
      }
    } else {
      btn.setAttribute('aria-disabled', 'true');
      if (this.initText && btn.textContent.trim() !== this.initText.trim()) {
        btn.textContent = this.initText;
      }
    }
  }

  onOptionChange(event) {
    const input = event.target;
    if (!input || !input.matches || !input.matches('input[data-option-position]')) return;
    this.userClickedPositions.add(input.getAttribute('data-option-position'));
  }

  onVariantChange() {
    setTimeout(this.refresh.bind(this), 0);
  }
}

if (!customElements.get('explicit-variant-controller')) {
  customElements.define('explicit-variant-controller', ExplicitVariantController);
}
